import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { DEFAULT_FEATURE_POLICIES, evaluateFeatureAccess } from '@hoedokloop/feature-policy';
import { usePlatform } from '../platform/platform-context';
import { sendProductEvent } from '../features/analytics/product-events';
export function PassPage() {
  const platform = usePlatform();
  const [message, setMessage] = useState<string>();
  const access = evaluateFeatureAccess({
    policy: DEFAULT_FEATURE_POLICIES.pass_season,
    network: navigator.onLine ? 'online' : 'offline',
    now: new Date().toISOString(),
  });
  const enabled = access.outcome === 'available';
  useEffect(() => {
    sendProductEvent(platform.analytics, 'paywall_viewed', {
      trigger: 'pass_page',
      productId: 'pass_season',
    });
  }, [platform.analytics]);
  return (
    <div className="pn-page">
      <Link to="/settings">설정으로</Link>
      <h1>합격 패스</h1>
      <p className="pn-policy-note">결제 준비 중이라 지금은 모든 기능을 무료로 열어 두었어요.</p>
      <h2>무료 공부 기록을 먼저 완성해요</h2>
      <p>
        시험 하나에 연결되고 결과 발표일, 발표일이 없으면 시험일+60일까지 이용하는 패스를 준비하고
        있어요. 같은 시험의 다음 회차로 이어가면 패스도 이어져요. 정기 구독이 아니므로 해지할 구독은
        없어요.
      </p>
      <h2>포함 기능</h2>
      <p>전체 오답집 만들기. 사진 글자 추출은 기능과 비용 조건이 정해지면 별도 안내해요.</p>
      <h2>무료로 계속 남는 것</h2>
      <p>
        시험 개수, 기록·수정·복원, 회독 지도, 플랜, 오답 복습, 점수·과락 확인, 알림, 백업·복원, CSV
        표 파일은 계속 무료예요. 오답집은 무료 최근 30문항을 체험 범위로 준비하지만, 지금은 전체를
        만들 수 있어요.
      </p>
      <Link className="pn-small-button" to="/notes/print">
        무료 오답집 만들기
      </Link>
      <button
        className="pn-small-button"
        onClick={() => {
          sendProductEvent(platform.analytics, 'pass_interest', {
            from:
              new URLSearchParams(location.search).get('from') === 'workbook_limit'
                ? 'workbook_limit'
                : 'pass_page',
          });
          setMessage(
            '지금은 전체 오답집을 무료로 만들 수 있어요. 구매 알림이나 연락처 등록은 하지 않아요.',
          );
        }}
      >
        합격 패스에 관심 있어요
      </button>
      <h2>환불과 복원</h2>
      <p>
        결제를 열면 토스·앱마켓의 환불 절차와 구매 기록 복원을 안내해요. 디지털 콘텐츠 청약철회를
        제한하려면 무료 체험 등 보완 조치를 먼저 제공해요. 미성년자가 법정대리인 동의 없이 구매한
        경우 취소는 앱마켓 절차를 따라요.
      </p>
      {import.meta.env['VITE_HOEDOKLOOP_CHANNEL'] === 'ait' ? (
        <section>
          <h2>구매 내역·기기 변경 복원</h2>
          <p>
            구매 내역이 없어요. 결제가 꺼져 있어 주문 번호나 사용자 식별 값을 새로 저장하지 않아요.
          </p>
          <button
            className="pn-small-button"
            disabled={!enabled}
            onClick={() =>
              void platform.payments
                .restore()
                .then((result) =>
                  setMessage(
                    result.ok
                      ? '구매 내역을 확인했어요.'
                      : '복원하지 못했어요. 다시 시도해 주세요.',
                  ),
                )
            }
          >
            구매 복원
          </button>
          <p>상품과 복원 경로가 열리면 같은 토스 계정으로 확인해요.</p>
        </section>
      ) : (
        <p>토스 앱 안에서 구매하는 경로를 준비 중이에요. 웹 구매 버튼은 아직 없어요.</p>
      )}
      {message ? <p role="status">{message}</p> : null}
      <Link to="/support">문의와 이용 안내</Link>
    </div>
  );
}
